// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Specific styles for the SingleColumnSelectModal */

/* Add a class to the modal content for specific targeting if needed */
.modal-content.single-column-modal {
  /* You can adjust width/height or other general modal styles here if needed */
  max-width: 550px; /* Example adjustment */
}

/* Style for individual column items in single-select mode */
.column-item.single-select-item {
  padding: 10px 12px; /* Slightly more padding */
  cursor: pointer; /* Indicate it's clickable */
  transition: background-color 0.2s ease;
  border-bottom: 1px solid #eee;
}

.column-item.single-select-item:last-child {
  border-bottom: none;
}

.column-item.single-select-item:hover {
  background-color: #f0f0f0; /* Lighter hover effect */
}

/* Style for the selected column item */
.column-item.single-select-item.selected {
  background-color: #d4edda; /* A light green background for selected */
  color: #155724; /* Darker text color for selected */
  font-weight: bold;
}

/* Ensure the fetch button is styled appropriately */
.fetch-all-columns-button {
    margin-bottom: 15px;
    padding: 10px 15px;
    /* Inherits button styles, add specifics if needed */
}

/* Loading message styling (if not already covered) */
.loading-message {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 15px;
    color: #555;
    font-style: italic;
}

.loading-message .spinner {
    margin-right: 10px;
} `, "",{"version":3,"sources":["webpack://./src/css/step3_ColumnSearchModal.css"],"names":[],"mappings":"AAAA,oDAAoD;;AAEpD,sEAAsE;AACtE;EACE,6EAA6E;EAC7E,gBAAgB,EAAE,uBAAuB;AAC3C;;AAEA,4DAA4D;AAC5D;EACE,kBAAkB,EAAE,0BAA0B;EAC9C,eAAe,EAAE,4BAA4B;EAC7C,sCAAsC;EACtC,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB,EAAE,yBAAyB;AACtD;;AAEA,uCAAuC;AACvC;EACE,yBAAyB,EAAE,0CAA0C;EACrE,cAAc,EAAE,mCAAmC;EACnD,iBAAiB;AACnB;;AAEA,oDAAoD;AACpD;IACI,mBAAmB;IACnB,kBAAkB;IAClB,oDAAoD;AACxD;;AAEA,qDAAqD;AACrD;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":["/* Specific styles for the SingleColumnSelectModal */\n\n/* Add a class to the modal content for specific targeting if needed */\n.modal-content.single-column-modal {\n  /* You can adjust width/height or other general modal styles here if needed */\n  max-width: 550px; /* Example adjustment */\n}\n\n/* Style for individual column items in single-select mode */\n.column-item.single-select-item {\n  padding: 10px 12px; /* Slightly more padding */\n  cursor: pointer; /* Indicate it's clickable */\n  transition: background-color 0.2s ease;\n  border-bottom: 1px solid #eee;\n}\n\n.column-item.single-select-item:last-child {\n  border-bottom: none;\n}\n\n.column-item.single-select-item:hover {\n  background-color: #f0f0f0; /* Lighter hover effect */\n}\n\n/* Style for the selected column item */\n.column-item.single-select-item.selected {\n  background-color: #d4edda; /* A light green background for selected */\n  color: #155724; /* Darker text color for selected */\n  font-weight: bold;\n}\n\n/* Ensure the fetch button is styled appropriately */\n.fetch-all-columns-button {\n    margin-bottom: 15px;\n    padding: 10px 15px;\n    /* Inherits button styles, add specifics if needed */\n}\n\n/* Loading message styling (if not already covered) */\n.loading-message {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 15px;\n    color: #555;\n    font-style: italic;\n}\n\n.loading-message .spinner {\n    margin-right: 10px;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
